import { useState, useCallback, useEffect } from 'react';
import { pushErrorFromAPI } from 'src/utilities/notifications';
import { IErrorResponse } from 'src/utilities/shared-types';
import { CorpUIResponse } from 'src/types/Corp';
import { CorporateFormFields } from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';
import { getCorporateDetails } from 'src/components/enterprise/features/Corporate/EditPage/functions/getCorporateApi';
import { getCateringServiceFee } from 'src/components/enterprise/features/Corporate/components/Form/CateringServiceFeeControl/api/cateringServiceFeeApi';
import { transformCorporateModelToUI } from 'src/components/enterprise/features/Corporate/utils/corporate.utilities';
import { transformCateringServiceFeeModelToUI } from 'src/components/enterprise/features/Corporate/components/Form/CateringServiceFeeControl/cateringServiceFeeControl.utils';

export type UseGetCorporateReturnType = {
  error: IErrorResponse;
  loading: boolean;
  corpFormValues?: CorporateFormFields;
  corpData?: CorpUIResponse;
};

export const useGetCorporate = (corpId: string): UseGetCorporateReturnType => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<IErrorResponse>();
  const [corpFormValues, setCorpFormData] = useState<CorporateFormFields>();
  const [corpData, setCorpData] = useState<CorpUIResponse>();

  const getCorporateTrigger = useCallback(async (): Promise<void> => {
    try {
      setIsLoading(true);
      const corpData = await getCorporateDetails(corpId);
      const serviceFeeData = await getCateringServiceFee(corpId);
      const cateringServiceFeeFormData =
        transformCateringServiceFeeModelToUI(serviceFeeData);
      const corporateFormData = transformCorporateModelToUI(
        corpData,
        cateringServiceFeeFormData
      );
      setCorpFormData(corporateFormData);
      setCorpData(corpData);
    } catch (error) {
      setError(error);
      pushErrorFromAPI(error);
    } finally {
      setIsLoading(false);
    }
  }, [corpId]);

  useEffect(() => {
    getCorporateTrigger();
  }, [getCorporateTrigger]);

  return {
    corpData,
    corpFormValues,
    error,
    loading: isLoading,
  };
};
